import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const SUPPORTED_LANGUAGES = ["en", "fr"] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

// Key used by the language detector to persist the choice in localStorage.
export const LANGUAGE_STORAGE_KEY = "lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      // "querystring" first: the marketing site (reviewcounter.ca) and this
      // app (app.reviewcounter.ca) are different origins, so localStorage
      // can't carry the visitor's language choice across the "Try free" /
      // "Start trial" links - those links append ?lang=fr|en instead, and
      // that always wins over a stale cached choice from a previous visit.
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

// Keep <html lang="…"> in sync so the browser and assistive tech pick it up.
const applyHtmlLang = (lng: string) => {
  document.documentElement.lang = lng;
};
applyHtmlLang(i18n.language || "en");
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
